import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import ThreadView from './components/ThreadView';
import PersonalThreadView from './components/PersonalThreadView';
import ChatSession from './components/ChatSession';
import MyChatSession from './components/MyChatSession';
import ShareChat from './components/ShareChat';
import UserProfile from './components/UserProfile';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import './App.css';

// Main app content component
function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="main-content">
        <div className="content-area">
          <Routes>
            <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <AuthPage />} />
            <Route path="/thread/:id" element={isAuthenticated ? <ThreadView /> : <AuthPage />} />
            <Route path="/personal/thread" element={isAuthenticated ? <PersonalThreadView /> : <AuthPage />} />
            <Route path="/chat/session/:hash_id/thread/:thread_id" element={<ChatSession />} />
            <Route path="/my/chat/session/:hash_id/thread/:thread_id" element={<MyChatSession />} />
            <Route path="/share/chat/thread/:thread_id" element={<ShareChat />} />
            <Route path="/user/:user_id/:username" element={<UserProfile />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
